export default (article) => {
    

    return  `
    <div class="row  justify-content-md-center ${article.pageTypeId}">
        <div class="${article.imageSpan}">
            <div class="article article__main article__template__${article.pageTypeId}">
                <h1 class="article__header">${article.title}</h1>
                ` +
                (article.parsedIntro.length > 2 ?
                    `<div class="article__intro">${article.parsedIntro}</div>` :
                    ``) +
                `
                <div>
                    ${article.mainImage}
                </div>
                <div class="article__content ${article.imageSpan=="col-md-10" ? `col-md-8` : ``}">
                    ${article.content}
                </div>
                <div class="article__datetext ${article.imageSpan=="col-md-10" ? `col-md-8` : ``}">
                    <p><span class="article__datetext__date article__datetext__date-published"><span class="article__datetext__label">Publisert:</span> ${article.firstCreated}</span></br>
                    <span class="article__datetext__date article__datetext__date-modified"><span class="article__datetext__label">Sist oppdatert:</span> ${article.modified}</span></p>
                </div>
            </div>
        </div>
        ${
          article.hasRightColumn
            ? `<div class="col-sm-4 offset-sm-1">${article.rightColumn}</div>`
            : ""
        }
    </div>
    `;
    
    
}